import React, { Component } from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

class WizardActionButtons extends Component {
    render() {
        const { wizards, showPrev, showNext, showFinish, goPrev, prevLabel, nextLabel, finishLabel, btnDisabled, wizardName, submitting } = this.props;
        const wizard = wizards[wizardName];
        let currentStep = 1;
        let totalSteps = 1;

        if (wizard) {
            currentStep = wizard.currentStep;
            totalSteps = wizard.totalSteps;
        }

        return <section className="actions clearfix">
            <ul role="menu" aria-label="Pagination">
                {showPrev &&
                    <li className={currentStep <= 1 ? "disabled" : ""} aria-disabled="true">
                        <button type="button" disabled={currentStep <= 1 ? "disabled" : ""} onClick={() => {
                            if (currentStep > 1) {
                                goPrev(wizard.name);
                            }
                        }}><Translate value={prevLabel || "misc.previous"} /></button>
                    </li>
                }
                {showNext && currentStep < totalSteps &&
                    <li className={currentStep >= totalSteps || btnDisabled ? "disabled" : ""} aria-hidden="false" aria-disabled={currentStep >= totalSteps || btnDisabled ? "true" : "false"}>
                        <button type="submit" disabled={currentStep >= totalSteps || btnDisabled ? "disabled" : ""}><Translate value={nextLabel || "misc.next"} /></button>
                    </li>
                }
                {showFinish && currentStep === totalSteps &&
                    <li className={btnDisabled ? "disabled" : ""} aria-hidden="false" aria-disabled={btnDisabled ? "true" : "false"}>
                        <button type="submit" disabled={btnDisabled || submitting ? "disabled" : ""}><Translate value={finishLabel || "misc.finish"} /></button>
                    </li>
                }
            </ul>
        </section>;
    }
}

function mapStateToProps(state) {
    return {
        wizards: state.wizards
    };
}

export default connect(mapStateToProps)(WizardActionButtons);
